
export const APP_VERSION = '1.0.34';
export const APP_VERSION_DEV = '1.0.63';
export const BUILD_DATE = '08-09-2026 09:55:38';
export const BUILD_NUMBER = '080920260955';
